<div class="pc-shell" #painelWrapper [class.tela-cheia]="telaCheiaAtiva">
  <div class="container" [class.container-tela-cheia]="telaCheiaAtiva">

    <!-- ── PAGE HEADER ── -->
    <div class="page-header">
      <div class="page-header-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="9 11 12 14 22 4"/>
          <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/>
        </svg>
      </div>
      <div style="flex:1">
        <h1>Painel de Conferência</h1>
        <p>Pedidos aguardando ou em processo de conferência</p>
      </div>

      <!-- Badge da empresa filtrada — visível mesmo em tela cheia. -->
      <div class="badge-empresa-painel" *ngIf="!legadoAberto"
           [style.background]="empresaState.corClaraPorCodEmp(empresaState.selecionada, 0.78)"
           [style.border-color]="empresaState.corPorCodEmp(empresaState.selecionada)">
        <span class="badge-empresa-dot" [style.background]="empresaState.corPorCodEmp(empresaState.selecionada)"></span>
        <span class="badge-empresa-texto">
          Empresa {{ empresaState.selecionada }}<ng-container *ngIf="nomeEmpresaAtual"> — {{ nomeEmpresaAtual }}</ng-container>
        </span>
      </div>

      <!-- Quando a fonte é o Sistema Legado (Aerosys), a "empresa" relevante é a
           do Aerosys sendo consultada -- vira um seletor aqui (mesmo padrão do
           Painel de Separação, ver carregarLegadoEmpresas/onLegadoEmpresaSelectChange). -->
      <div class="badge-empresa-painel badge-empresa-legado" *ngIf="legadoAberto">
        <span class="badge-empresa-dot dot-legado"></span>
        <span class="badge-empresa-texto" *ngIf="legadoEmpresasCarregando"><app-loading-indicator size="inline"></app-loading-indicator> Carregando empresas...</span>
        <select
          *ngIf="!legadoEmpresasCarregando"
          class="sel-empresa-legado"
          [ngModel]="legadoEmpresaSelecionada?.id ?? null"
          (ngModelChange)="onLegadoEmpresaSelectChange($event)"
          title="Empresa do Sistema Legado (Aerosys)"
        >
          <option *ngIf="!legadoEmpresaSelecionada" [ngValue]="null" disabled>Selecione a empresa...</option>
          <option *ngFor="let emp of legadoEmpresas" [ngValue]="emp.id">
            {{ emp.nome || emp.razao || ('Empresa ' + emp.id) }}
          </option>
        </select>
      </div>

      <!-- Sumário rápido -->
      <div class="header-stats" *ngIf="!carregandoLinhas && linhas.length > 0">
        <div class="stat-chip stat-aguardando">
          <span class="stat-num">{{ totalAguardando }}</span>
          <span class="stat-label">Aguardando</span>
        </div>
        <div class="stat-chip stat-em-conf">
          <span class="stat-num">{{ totalConferencia }}</span>
          <span class="stat-label">Em Conferência</span>
        </div>
      </div>

      <div class="header-actions">
        <div class="timer-config">
          <label for="timerInputConf">Atualizar a cada (s):</label>
          <input id="timerInputConf" type="number" class="input-timer" [(ngModel)]="intervaloAtualizacao"
            (change)="onIntervaloChange()" min="1" max="3600" />
        </div>

        <button type="button" class="btn-novo" (click)="atualizar()" [disabled]="carregandoLinhas">
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="23 4 23 10 17 10"/>
            <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/>
          </svg>
          <span *ngIf="!telaCheiaAtiva">Atualizar {{ tempoRestante > 0 ? '(' + tempoRestante + 's)' : '' }}</span>
        </button>

        <button type="button" class="btn-novo btn-secundario" (click)="alternarTelaCheia()">
          <svg *ngIf="!telaCheiaAtiva" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24"
            fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"/>
          </svg>
          <svg *ngIf="telaCheiaAtiva" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24"
            fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M8 3v3a2 2 0 0 1-2 2H3m18 0h-3a2 2 0 0 1-2-2V3m0 18v-3a2 2 0 0 1 2-2h3M3 16h3a2 2 0 0 1 2 2v3"/>
          </svg>
          <span *ngIf="!telaCheiaAtiva">Maximizar</span>
          <span *ngIf="telaCheiaAtiva">Sair</span>
        </button>

        <!-- Indicador (não clicável) de que este usuário vê o Sistema Legado nesta
             tabela — a fonte é definida pela permissão PAIAER, não por um toggle. -->
        <div *ngIf="podeVerVendasLegado" class="badge-fonte-legado" title="Esta tabela mostra as vendas do Sistema Legado (Aerosys), não os pedidos do Sankhya">
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <rect x="3" y="3" width="18" height="18" rx="2"></rect>
            <line x1="9" y1="9" x2="15" y2="9"></line>
            <line x1="9" y1="13" x2="15" y2="13"></line>
            <line x1="9" y1="17" x2="12" y2="17"></line>
          </svg>
          <span>Sistema Legado</span>
          <span class="legado-badge-count" *ngIf="legadoEmpresaSelecionada && legadoLista.length > 0">{{ legadoLista.length }}</span>
        </div>
      </div>
    </div>

    <!-- ── ERRO ── -->
    <div *ngIf="erro" class="alerta alerta-erro">{{ erro }}</div>
    <div *ngIf="legadoAberto && legadoEmpresasErro" class="alerta alerta-erro">{{ legadoEmpresasErro }}</div>
    <div *ngIf="legadoAberto && legadoErro" class="alerta alerta-erro">{{ legadoErro }}</div>
    <div *ngIf="legadoAberto && legadoEmpresaSelecionada == null && !legadoEmpresasCarregando && legadoEmpresas.length === 0 && !legadoEmpresasErro" class="alerta alerta-erro">
      Nenhuma empresa do Sistema Legado disponível para este usuário.
    </div>

    <!-- ── TABELA ── -->
    <div class="tabela-card" *ngIf="!aguardandoEscolhaEmpresaLegado">

      <div *ngIf="carregandoLinhas" class="loading-row">
        <app-loading-indicator></app-loading-indicator>
        <span>Carregando conferências...</span>
      </div>

      <div *ngIf="!carregandoLinhas && linhas.length === 0 && !erro" class="vazio-row">
        {{ legadoAberto ? 'Nenhuma venda em conferência encontrada no Sistema Legado.' : 'Nenhum pedido aguardando ou em conferência.' }}
      </div>

      <ng-container *ngIf="!carregandoLinhas && linhas.length > 0">
        <table class="tabela">
          <thead>
            <tr>
              <th>{{ legadoAberto ? 'N° Venda' : 'N° Único' }}</th>
              <th class="col-center">Emissão</th>
              <th>Cliente</th>
              <th>Vendedor</th>
              <th class="col-center">Prefixo</th>
              <th>Conferente</th>
              <th class="col-center">Início Conf.</th>
              <th class="col-center">Progresso</th>
              <th class="col-center">Prioridade</th>
              <th class="col-center">Imediato</th>
              <th class="col-center">Status</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let p of pedidosPagina" class="linha-clicavel" [class.linha-legado]="p.origem === 'aerosys'">
              <td class="col-nunota">
                {{ p.origem === 'aerosys' ? p.numTituloLegado : p.nunota }}
              </td>
              <td class="col-center col-data">{{ p.dtneg || '—' }}</td>
              <td class="col-cliente">{{ p.nomeCliente }}</td>
              <td class="col-vend">{{ p.vendedor }}</td>
              <td class="col-center">
                <span *ngIf="p.prefixo" class="badge-prefixo">{{ p.prefixo }}</span>
                <span *ngIf="!p.prefixo" class="col-vazio">—</span>
              </td>
              <td class="col-sep">
                <span *ngIf="p.confNome">{{ p.confNome }}</span>
                <span *ngIf="!p.confNome" class="col-vazio">—</span>
              </td>
              <td class="col-center col-data">{{ p.dataInicio || '—' }}</td>
              <td class="col-center">
                <span *ngIf="p.totalItens > 0 && p.qtdConferidos > 0" class="progresso-texto">
                  {{ p.qtdConferidos }}/{{ p.totalItens }}
                  <span class="progresso-pct">({{ (p.qtdConferidos / p.totalItens * 100) | number:'1.0-0' }}%)</span>
                </span>
                <span *ngIf="!p.qtdConferidos" class="col-vazio">—</span>
              </td>
              <td class="col-center">
                <span class="badge-prioridade" [class.badge-alta]="p.prioridade === 'Alta'">
                  {{ p.prioridade || 'Normal' }}
                </span>
              </td>
              <td class="col-center">
                <span class="badge-imediato" *ngIf="p.imediato === 'Sim'">Imediato</span>
                <span class="badge-normal" *ngIf="p.imediato !== 'Sim'">-</span>
              </td>
              <td class="col-center">
                <span class="status-badge" [ngClass]="statusClass(p.status)">{{ p.status }}</span>
              </td>
            </tr>
          </tbody>
        </table>

        <!-- ── RODAPÉ ── -->
        <div class="tabela-rodape">
          <span class="rodape-total">
            {{ linhas.length }} pedido{{ linhas.length !== 1 ? 's' : '' }}
          </span>

          <div class="rodape-paginacao">
            <div class="por-pagina">
              <span>Exibir</span>
              <select [(ngModel)]="itensPorPagina" (ngModelChange)="onItensPorPaginaChange()" class="sel-pagina">
                <option *ngFor="let n of opcoesPorPagina" [value]="n">{{ n }}</option>
              </select>
              <span>por página</span>
            </div>

            <div class="pag-controles">
              <button class="pag-btn" (click)="irParaPagina(1)" [disabled]="paginaAtual === 1" title="Primeira">«</button>
              <button class="pag-btn" (click)="irParaPagina(paginaAtual - 1)" [disabled]="paginaAtual === 1" title="Anterior">‹</button>
              <button *ngIf="paginas[0] > 1" class="pag-btn pag-ellipsis" disabled>…</button>
              <button *ngFor="let p of paginas" class="pag-btn" [class.pag-ativo]="p === paginaAtual" (click)="irParaPagina(p)">{{ p }}</button>
              <button *ngIf="paginas[paginas.length - 1] < totalPaginas" class="pag-btn pag-ellipsis" disabled>…</button>
              <button class="pag-btn" (click)="irParaPagina(paginaAtual + 1)" [disabled]="paginaAtual === totalPaginas" title="Próxima">›</button>
              <button class="pag-btn" (click)="irParaPagina(totalPaginas)" [disabled]="paginaAtual === totalPaginas" title="Última">»</button>
            </div>
          </div>
        </div>
      </ng-container>
    </div>

  </div>
</div>
